import React from 'react';
import cx from 'classnames';

import Button from '~/components/button';
import { ReviewStars } from '~/components/static/smart-lawn-plan/review';
import { useModal } from '~/features/modals/modal-actions';

import styles from '~/components/static/reviews/reviews.module.scss';

const REVIEWS_RATING = 4.3;

export const ReviewsElement = ({
  copy = '10,000+ reviews',
  linkAnchor,
  variant,
}) => (
  <div
    className={cx(styles.reviewsElementContainer, {
      [styles.dark]: variant === 'dark',
    })}
  >
    <ReviewStars rating={REVIEWS_RATING} />
    {linkAnchor ? (
      <>
        <a href={linkAnchor}>{copy}</a>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 8 8"
          style={{ marginTop: '0.4rem' }}
        >
          <path
            d="M.536 3.401l-.407.4a.419.419 0 000 .605l3.56 3.471a.446.446 0 00.621 0l3.56-3.469a.419.419 0 000-.605l-.407-.4a.448.448 0 00-.628.007l-2.1 2.15V.429A.433.433 0 004.295 0h-.587a.433.433 0 00-.44.429V5.56l-2.1-2.152a.445.445 0 00-.628-.007z"
            fill={
              variant === 'dark'
                ? 'var(--secondary-dark-color)'
                : 'var(--light-color)'
            }
          />
        </svg>
      </>
    ) : (
      <span>{copy}</span>
    )}
  </div>
);

export const ReviewsModalTrigger = ({
  buttonCopy = '10,000+ reviews',
  buttonDisabled,
  className,
  variant,
}) => {
  const { showModal } = useModal();

  return (
    <div
      className={cx(styles.reviewsElementContainer, className, {
        [styles.dark]: variant === 'dark',
      })}
    >
      <p>{REVIEWS_RATING}</p>
      <ReviewStars rating={REVIEWS_RATING} />
      <Button
        className={styles.modalTriggerButton}
        disabled={buttonDisabled}
        data-heap-id="lawn-reviews-modal-trigger"
        variant="link"
        onClick={() => showModal('LAWN_PLAN_REVIEWS')}
      >
        {buttonCopy}
      </Button>
    </div>
  );
};
